<script>
import getSecret from "@utils/get-secret";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import BaseDatatable from "@components/base-datatable";
import UsersUpdateForm from "@views/management/users/update-form";
import UsersCreateForm from "@views/management/users/create-form";
import UsersUpdatePwForm from "@views/management/users/update-pw-form";
import { storesMethods, authComputed } from "@state/helpers";
import { required, minLength, email, sameAs } from "vuelidate/lib/validators";
import ActionButton from "@components/buttons/ActionButton";
import FormSelect from "@components/form/Select";
import NewStore from "@views/stores/new-store";
export default {
  page: {
    title: "Administration/Stores",
    meta: [{ name: "Store Administration", content: "Administration/Stores" }],
  },
  components: {
    Layout,
    PageHeader,
    BaseDatatable,
    UsersCreateForm,
    UsersUpdateForm,
    UsersUpdatePwForm,
    ActionButton,
    FormSelect,
    NewStore,
  },
  data() {
    return {
      title: "Stores",
      items: [
        {
          text: "Stores",
          href: "/",
        },
      ],
      users: {},
      tableHeaders: [
        {
          key: "name",
          sortable: true,
        },
        {
          key: "address",
          sortable: true,
        },
        {
          key: "access_points",
          label: "#access_points",
          sortable: true,
        },
        {
          key: "subscription_active",
          label: "Subscription_active",
        },
        {
          key: "actions",
          label: "Actions",
        },
      ],
      detailModal: {
        id: "info-modal",
        title: "",
        content: "",
        photo: "",
      },
      createUpdateModal: {
        id: "create-update-modal",
        title: "",
        content: "",
      },
      createForm: {
        name: "",
        address: "",
      },
      updateForm: {
        name: "",
        address: "",
        map: "",
        company: "",
        users: [],
      },
      action: "",
      createModal: false,
      updateModal: false,
      toDelete: {},
      actionsLoadings: {},
      createUpdateModalShow: false,
      detailModalShow: false,
      deleteModalShow: false,
      isSubmitting: false,
      filters: {
        _id: null,
      },
      filterset: null,
    };
  },
  validations: {
    updateForm: {
      name: {
        required,
        minLength: minLength(4),
      },
      address: {
        required,
        minLength: minLength(4),
      },
      map: "",
      company: { minLength: minLength(8) },
    },
    createForm: {
      name: {
        required,
        minLength: minLength(4),
      },
      address: {
        required,
        minLength: minLength(4),
      },
      map: {},
      company: { minLength: minLength(8) },
    },
  },
  mounted() {},
  watch: {
    filters: {
      deep: true,
      handler(filters) {
        let filters_list = [];
        for (let filter in filters) {
          if (filters[filter]) {
            filters_list.push(`${filter}=${filters[filter]}`);
          }
        }
        // if (filters_list.length) {
        this.filterset = filters_list.join("&");
        // }
        this.filter();
      },
    },
  },
  methods: {
    ...storesMethods,
    ...authComputed,
    myProvider(ctx) {
      ctx = this.$table_params(ctx);
      ctx += this.filterset ? `&${this.filterset}` : "";
      const promise = this.fetchStores(ctx);
      return promise
        .then((data) => {
          console.log(data);
          return data;
        })
        .catch((error) => {
          this.$axios_error_noty(error, this);
          return [];
        });
    },
    fetchStoresOptions() {
      const promise = this.fetchStores("?origin=multiselect");
      return promise
        .then((data) => {
          console.log(data);
          return data;
        })
        .catch((error) => {
          this.$axios_error_noty(error, this);
          return [];
        });
    },
    filter() {
      this.$refs.table.lastFilter = "";
      this.$refs.table.onFiltered();
      setTimeout(() => this.$refs.table.refresh(), 200);
    },
    setFilter(filter, value) {
      console.log(filter, value);
      this.filters[filter] = value;
    },
    createStore(evt) {
      evt.preventDefault();
      this.isSubmitting = true;
      this.createUpdateStores(this.createForm)
        .then((res) => {
          this.$generate_toast(this, "success", this.$t(res.msg));
          this.isSubmitting = false;
          this.createModal = !this.createModal;
          this.$refs.table.refresh();
        })
        .catch((err) => {
          console.log(err);
          this.isSubmitting = true;
        });
    },
    updateStore(evt) {
      evt.preventDefault();
      this.isSubmitting = true;
      this.createUpdateStores(this.updateForm)
        .then((res) => {
          this.$generate_toast(this, "success", this.$t(res.msg));
          this.isSubmitting = false;
          this.createModal = !this.createModal;
          this.$refs.table.refresh();
        })
        .catch((err) => {
          console.log(err);
          this.isSubmitting = true;
        });
    },
    // openDeleteModal(item, index) {
    //   this.toDelete = item;
    //   this.deleteModalShow = !this.deleteModalShow;
    // },
    // resetDeleteModal(item, index) {
    //   this.toDelete = {};
    // },
    // deleteUser() {
    //   let context = this;
    //   context.isSubmitting = true;
    //   // let reservedUsers = [
    //   //   getSecret('APP_API_USERNAME'),
    //   //   context.currentSession.user.username]
    //   // if(!reservedUsers.includes(context.toDelete.username)){
    //   const promise = context.deleteUsers(context.toDelete._id);
    //   return promise
    //     .then((data) => {
    //       context.$generate_toast(
    //         context,
    //         "success",
    //         context.$t("alerts.deleted_successfully")
    //       );
    //       context.$refs.table.refresh();
    //       context.isSubmitting = false;
    //     })
    //     .catch((error) => {
    //       context.$axios_error_noty(error, context);
    //       context.isSubmitting = false;
    //     });
    //   // }else{
    //   //   context.$generate_toast(
    //   //     context,
    //   //     'error',
    //   //     'This user cannot be deleted because is protected or is yourself')
    //   //   context.isSubmitting = false
    //   // }
    // },
    // async onPhotoSubmit(formData) {
    //   let context = this;
    //   context.isSubmitting = true;
    //   formData.append("url", context.updateForm.url);
    //   return context
    //     .updatePhotos(formData)
    //     .then((data) => {
    //       context.$generate_toast(
    //         context,
    //         "success",
    //         context.$t("alerts.updated_successfully")
    //       );
    //       context.isSubmitting = false;
    //       context.$refs.table.refresh();
    //       if (context.currentSession.user.username === context.updateForm.username) {
    //         this.$store.dispatch("auth/validate", true);
    //       }
    //       return data;
    //     })
    //     .catch((error) => {
    //       context.$axios_error_noty(error, context);
    //       context.isSubmitting = false;
    //       throw error;
    //     });
    // },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-container fluid class="p-0">
      <b-row>
        <b-col>
          <b-card>
            <b-button
              variant="primary"
              size="sm"
              @click="
                () => {
                  createModal = true;
                }
              "
            >
              <i class="fad fa-plus"></i> {{ $t("basic.add") }}
            </b-button>
            <BaseDatatable
              ref="table"
              :drfprovider="myProvider"
              :tableheaders="tableHeaders"
            >
              <template v-slot:filters>
                <b-row>
                  <b-col class="px-0">
                    <FormSelect
                      :value="filters._id"
                      :label="$t('name')"
                      :fetchOptions="fetchStoresOptions"
                      @input="(value) => setFilter('_id', value)"
                    />
                  </b-col>
                </b-row>
              </template>
              <template v-slot:cell(access_points)="row">
                {{ row.item.access_points_count }}
              </template>
              <template v-slot:cell(subscription_active)="row">
                <div class="d-flex align-items-center" style="gap: 0.5rem">
                  <b-spinner type="grow" label="Spinning" variant="danger"></b-spinner>
                  <p class="m-0 p-0">Not Active</p>
                </div>
              </template>
              <template v-slot:cell(actions)="row">
                <div>
                  <ActionButton
                    :id="`info-${row.index}`"
                    variant="info"
                    :hover_text="'Edit'"
                    icon_class="fad fa-pen font-24"
                  >
                  </ActionButton>
                </div>
              </template>
            </BaseDatatable>
          </b-card>
        </b-col>
      </b-row>
      <b-modal v-model="createModal" :title="'Crear nueva sucursal'" :size="'lg'">
        <NewStore :onFormSubmit="createStore" :form="createForm"></NewStore>
        <template v-slot:modal-footer>
          <b-button
            variant="secondary"
            size="sm"
            class="float-right"
            @click="
              () => {
                createModal = !createModal;
              }
            "
          >
            {{ $t("basic.cancel") }}
          </b-button>
          <b-button type="submit" form="form" size="sm" variant="primary">
            <span v-if="!isSubmitting">
              {{ $t("submit") }}
            </span>
            <b-spinner v-if="isSubmitting" small label="Spinning" variant="light">
            </b-spinner>
          </b-button>
        </template>
      </b-modal>
      <b-modal v-model="updateModal" :title="'Crear nueva sucursal'" :size="'lg'">
        <NewStore :onFormSubmit="updateStore" :form="updateForm"></NewStore>
        <template v-slot:modal-footer>
          <b-button
            variant="secondary"
            size="sm"
            class="float-right"
            @click="
              () => {
                updateModal = !updateModal;
              }
            "
          >
            {{ $t("basic.cancel") }}
          </b-button>
          <b-button type="submit" form="form" size="sm" variant="primary">
            <span v-if="!isSubmitting">
              {{ $t("submit") }}
            </span>
            <b-spinner v-if="isSubmitting" small label="Spinning" variant="light">
            </b-spinner>
          </b-button>
        </template>
      </b-modal>
    </b-container>
  </Layout>
</template>
